import React, { useState, useEffect } from 'react';

const SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbzNiQEYadVTgvDj-xKEPOWmiCFnjo2KZj1go-P28IV3kSd1fxS1BRuctD863KXXI0f1dQ/exec';
const NOTIFY_EMAIL = 'snoc@sowash.pk';

const inp = { padding: '9px 12px', border: '1.5px solid #e5e7eb', borderRadius: '7px', fontSize: '13px', outline: 'none', width: '100%', boxSizing: 'border-box', background: '#fff' };

const Section = ({ title, urdu, badge, color = '#1e3a8a', children }) => (
  <div style={{ marginBottom: '20px' }}>
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#f8fafc', borderLeft: `4px solid ${color}`, borderRadius: '6px', padding: '10px 14px', marginBottom: '12px' }}>
      <div>
        <span style={{ fontWeight: '700', fontSize: '14px', color: '#0f172a' }}>{title}</span>
        <span style={{ marginLeft: '10px', fontSize: '13px', color: '#6b7280' }}>{urdu}</span>
      </div>
      {badge && <span style={{ background: color, color: 'white', padding: '2px 10px', borderRadius: '50px', fontSize: '12px', fontWeight: '700' }}>{badge}</span>}
    </div>
    {children}
  </div>
);

const Field = ({ label, urdu, children }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px' }}>
      <span style={{ fontWeight: '600', color: '#374151' }}>{label}</span>
      <span style={{ color: '#9ca3af' }}>{urdu}</span>
    </div>
    {children}
  </div>
);

const RadioCard = ({ selected, onClick, children, accent = '#1e3a8a' }) => (
  <label onClick={onClick} style={{ display: 'flex', gap: '8px', padding: '10px 12px', border: `1.5px solid ${selected ? accent : '#e5e7eb'}`, borderRadius: '8px', cursor: 'pointer', background: selected ? `${accent}18` : '#fafafa', alignItems: 'flex-start' }}>
    {children}
  </label>
);

const CheckCard = ({ checked, onChange, label, urdu, bonus, accent = '#059669' }) => (
  <label style={{ display: 'flex', gap: '8px', padding: '10px 12px', border: `1.5px solid ${checked ? accent : '#e5e7eb'}`, borderRadius: '8px', cursor: 'pointer', background: checked ? `${accent}18` : '#fafafa', alignItems: 'center' }}>
    <input type="checkbox" checked={checked} onChange={onChange} />
    <div style={{ flex: 1 }}>
      <div style={{ fontSize: '13px', fontWeight: '600', color: '#111827' }}>{label}</div>
      <div style={{ fontSize: '12px', color: '#6b7280' }}>{urdu}</div>
    </div>
    {bonus && <span style={{ fontSize: '12px', fontWeight: '700', color: accent, whiteSpace: 'nowrap' }}>{bonus}</span>}
  </label>
);

const HiringForm = () => {
  const [formData, setFormData] = useState({
    candidateName: '', age: '', cnic: '', contactNo: '', position: '',
    address: '', fatherName: '', date: new Date().toISOString().split('T')[0], areaSite: '',
  });
  const [scores, setScores] = useState({
    technical: 0, experience: 0, qualification: 0, extraCert: false,
    areaAttributes: { outdoor: false, fitness: false, localFamiliarity: false, travel: false, urdu: false, english: false, bike: false },
    safety: { ppe: false, electricalHeight: false, discipline: false, digitalSkills: false }
  });
  const [totalScore, setTotalScore] = useState(0);
  const [decision, setDecision] = useState('');
  const [remarks, setRemarks] = useState('');
  const [evaluatorName, setEvaluatorName] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    let s = (parseInt(scores.technical) || 0) + (parseInt(scores.experience) || 0) + (parseInt(scores.qualification) || 0);
    if (scores.extraCert) s += 5;
    Object.values(scores.areaAttributes).forEach((val, idx) => { if (val) s += (idx === 1 || idx === 2) ? 10 : 5; });
    Object.values(scores.safety).forEach(val => { if (val) s += 5; });
    setTotalScore(s);
    if (s > 0) setDecision(s >= 78 ? 'Supervisor' : s >= 38 ? 'FO' : 'Not Selected');
    else setDecision('');
  }, [scores]);

  const handleInputChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });
  const handleScoreChange = (cat, val) => setScores({ ...scores, [cat]: val });
  const handleCheckboxChange = (cat, field) => {
    if (cat === 'extraCert') setScores({ ...scores, extraCert: !scores.extraCert });
    else setScores({ ...scores, [cat]: { ...scores[cat], [field]: !scores[cat][field] } });
  };

  const areaScore = [
    scores.areaAttributes.outdoor ? 5 : 0,
    scores.areaAttributes.fitness ? 10 : 0,
    scores.areaAttributes.localFamiliarity ? 10 : 0,
    scores.areaAttributes.travel ? 5 : 0,
    scores.areaAttributes.urdu ? 5 : 0,
    scores.areaAttributes.english ? 5 : 0,
    scores.areaAttributes.bike ? 5 : 0,
  ].reduce((a, b) => a + b, 0);
  const safetyScore = Object.values(scores.safety).filter(Boolean).length * 5;
  const decisionColor = (decision === 'Supervisor' || decision === 'FO') ? '#059669' : decision === 'Not Selected' ? '#dc2626' : '#6b7280';

  const getTechnicalLabel = (val) => ({ '0': '0 - No Knowledge', '5': '5 - Basic Knowledge', '10': '10 - Intermediate', '15': '15 - Expert' })[String(val)] || 'Not Selected';
  const getExperienceLabel = (val) => ({ '0': '< 1 year', '10': '1-3 years', '15': '3-5 years', '20': '5+ years' })[String(val)] || 'Not Selected';
  const getQualificationLabel = (val) => ({ '0': 'Below Matric', '10': 'Matric/Inter', '15': 'Diploma', '20': 'Bachelors' })[String(val)] || 'Not Selected';

  const handleSave = async () => {
    if (!formData.candidateName.trim()) {
      alert('⚠️ Please enter Candidate Name before saving.\nامیدوار کا نام ضروری ہے۔');
      return;
    }

    setIsSubmitting(true);

    // Email sirf FO ya Supervisor pe bhejna hai
    const shouldSendEmail = decision === 'FO' || decision === 'Supervisor';

    const payload = {
      // ── EMPLOYEE INFO ──
      'Candidate Name | امیدوار کا نام': formData.candidateName,
      'Age | عمر': formData.age,
      'CNIC | شناختی کارڈ': formData.cnic,
      'Contact No. | رابطہ نمبر': formData.contactNo,
      'Position | عہدہ': formData.position,
      "Father's Name | والد کا نام": formData.fatherName,
      'Date | تاریخ': formData.date,
      'Address | پتہ': formData.address,
      'Area/Site | علاقہ / سائٹ': formData.areaSite,

      // ── SECTION 1 ──
      'Q1. Technical Knowledge Level | تکنیکی علم': getTechnicalLabel(scores.technical),
      'Q1. Technical Score (Max 15)': parseInt(scores.technical) || 0,

      // ── SECTION 2 ──
      'Q2. Work Experience | کام کا تجربہ': getExperienceLabel(scores.experience),
      'Q2. Experience Score (Max 20)': parseInt(scores.experience) || 0,

      // ── SECTION 3 ──
      'Q3. Qualification | تعلیمی قابلیت': getQualificationLabel(scores.qualification),
      'Q3. Qualification Score (Max 20)': parseInt(scores.qualification) || 0,
      'Q3b. Extra Certificates - Solar/Safety | اضافی سرٹیفکیٹ': scores.extraCert ? 'Yes | ہاں (+5)' : 'No | نہیں',
      'Q3b. Extra Cert Score (Max 5)': scores.extraCert ? 5 : 0,

      // ── SECTION 4 ──
      'Q4a. Outdoor Work (heat/dust) | بیرونی کام': scores.areaAttributes.outdoor ? 'Yes (+5)' : 'No',
      'Q4b. Physical Fitness | جسمانی صحت': scores.areaAttributes.fitness ? 'Yes (+10)' : 'No',
      'Q4c. Local Site/Route Knowledge | مقامی راستوں کا علم': scores.areaAttributes.localFamiliarity ? 'Yes (+10)' : 'No',
      'Q4d. Willingness to Travel/Night Duty | سفر / رات کی ڈیوٹی': scores.areaAttributes.travel ? 'Yes (+5)' : 'No',
      'Q4e. Read & Write Urdu | اردو لکھنا پڑھنا': scores.areaAttributes.urdu ? 'Yes (+5)' : 'No',
      'Q4f. Read & Write English | انگریزی لکھنا پڑھنا': scores.areaAttributes.english ? 'Yes (+5)' : 'No',
      'Q4g. Can Drive a Bike | بائیک چلا سکتا ہے': scores.areaAttributes.bike ? 'Yes (+5)' : 'No',
      'Q4. Area & Mobility Score (Max 45)': areaScore,

      // ── SECTION 5 ──
      'Q5a. Use of PPE | حفاظتی سامان کا استعمال': scores.safety.ppe ? 'Yes (+5)' : 'No',
      'Q5b. Electrical & Height Safety | بجلی اور اونچائی': scores.safety.electricalHeight ? 'Yes (+5)' : 'No',
      'Q5c. Discipline & SOP Compliance | نظم و ضبط': scores.safety.discipline ? 'Yes (+5)' : 'No',
      'Q5d. Smartphone / Laptop Use | ڈیجیٹل مہارت': scores.safety.digitalSkills ? 'Yes (+5)' : 'No',
      'Q5. Safety & Discipline Score (Max 20)': safetyScore,

      // ── RESULT ──
      'Total Score | کل نمبر': totalScore,
      'Out Of | کل ممکنہ نمبر': 125,
      'Hiring Decision | بھرتی کا فیصلہ': decision || 'Pending',
      'Remarks | ریمارکس': remarks,
      'Evaluator Name | جائزہ لینے والے کا نام': evaluatorName,
      'Submitted At | جمع کرانے کا وقت': new Date().toLocaleString('en-PK'),

      // ── EMAIL FLAG (Apps Script is read karta hai) ──
      '_sendEmail': shouldSendEmail,
      '_notifyTo': NOTIFY_EMAIL,
      '_emailSubject': shouldSendEmail
        ? `✅ New Hire Selected: ${formData.candidateName} — ${decision}`
        : '',
    };

    try {
      const response = await fetch(SCRIPT_URL, {
        method: 'POST',
        body: JSON.stringify(payload),
      });
      const result = await response.json();

      if (result.success) {
        const emailMsg = shouldSendEmail
          ? `\n📧 Notification email sent to ${NOTIFY_EMAIL}`
          : '';
        alert(`✅ Form saved successfully!${emailMsg}\n\nفارم کامیابی سے محفوظ ہو گیا!`);
      } else {
        alert('❌ Error: ' + (result.message || 'Unknown error.'));
      }
    } catch {
      alert('❌ Failed to save. Check internet connection.\nانٹرنیٹ کنیکشن چیک کریں۔');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', padding: '16px', fontFamily: "'Segoe UI', system-ui, sans-serif" }}>
      <div style={{ maxWidth: '900px', margin: '0 auto' }}>

        {/* HEADER */}
        <div style={{ background: 'white', borderRadius: '14px 14px 0 0', padding: '18px 24px', display: 'flex', alignItems: 'center', gap: '16px', borderBottom: '4px solid #1e3a8a' }}>
          <div style={{ width: '54px', height: '54px', borderRadius: '10px', background: 'linear-gradient(135deg, #1e3a8a, #2563eb)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '26px', flexShrink: 0 }}>🏢</div>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: '17px', fontWeight: '800', color: '#0f172a' }}>EMPLOYEE HIRING QUESTIONNAIRE</div>
            <div style={{ fontSize: '14px', color: '#1e3a8a', fontWeight: '500' }}>ملازم بھرتی سوالنامہ</div>
          </div>
          <div style={{ textAlign: 'right' }}>
            <div style={{ fontSize: '10px', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '1px' }}>Total Score</div>
            <div style={{ fontSize: '30px', fontWeight: '900', color: '#1e3a8a', lineHeight: 1 }}>{totalScore}<span style={{ fontSize: '14px', color: '#9ca3af', fontWeight: '400' }}>/125</span></div>
          </div>
        </div>

        {/* BODY */}
        <div style={{ background: '#fff', padding: '22px 24px', borderRadius: '0 0 14px 14px', boxShadow: '0 20px 50px rgba(0,0,0,0.35)' }}>

          {/* INFO */}
          <Section title="Employee Information" urdu="ملازم کی معلومات" color="#1e3a8a">
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(170px, 1fr))', gap: '12px' }}>
              <Field label="Candidate Name" urdu="امیدوار کا نام"><input style={inp} name="candidateName" value={formData.candidateName} onChange={handleInputChange} placeholder="Full name" /></Field>
              <Field label="Age" urdu="عمر"><input style={inp} name="age" type="number" value={formData.age} onChange={handleInputChange} placeholder="25" /></Field>
              <Field label="CNIC/ID" urdu="شناختی کارڈ"><input style={inp} name="cnic" value={formData.cnic} onChange={handleInputChange} placeholder="xxxxx-xxxxxxx-x" /></Field>
              <Field label="Contact No." urdu="رابطہ نمبر"><input style={inp} name="contactNo" value={formData.contactNo} onChange={handleInputChange} placeholder="03xx-xxxxxxx" /></Field>
              <Field label="Position" urdu="عہدہ"><input style={inp} name="position" value={formData.position} onChange={handleInputChange} placeholder="Job title" /></Field>
              <Field label="Father's Name" urdu="والد کا نام"><input style={inp} name="fatherName" value={formData.fatherName} onChange={handleInputChange} placeholder="Father's name" /></Field>
              <Field label="Date" urdu="تاریخ"><input type="date" style={inp} name="date" value={formData.date} onChange={handleInputChange} /></Field>
              <Field label="Address" urdu="پتہ"><input style={inp} name="address" value={formData.address} onChange={handleInputChange} placeholder="City, Area" /></Field>
              <Field label="Area / Site" urdu="علاقہ / سائٹ"><input style={inp} name="areaSite" value={formData.areaSite} onChange={handleInputChange} placeholder="Site name" /></Field>
            </div>
          </Section>

          {/* SEC 1 */}
          <Section title="1. Technical Knowledge" urdu="تکنیکی علم" badge={`${scores.technical}/15`} color="#2563eb">
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(185px, 1fr))', gap: '10px' }}>
              {[
                { val: 0, title: "0 - No Knowledge", urdu: "کوئی علم نہیں", desc: "No understanding of cleaning process." },
                { val: 5, title: "5 - Basic", urdu: "بنیادی علم", desc: "Simple do's and don'ts." },
                { val: 10, title: "10 - Intermediate", urdu: "درمیانہ علم", desc: "Water pressure & safety control." },
                { val: 15, title: "15 - Expert", urdu: "ماہرانہ علم", desc: "Techniques & damage prevention." }
              ].map(opt => (
                <RadioCard key={opt.val} selected={String(scores.technical) === String(opt.val)} onClick={() => handleScoreChange('technical', opt.val)} accent="#2563eb">
                  <input type="radio" name="technical" value={opt.val} checked={String(scores.technical) === String(opt.val)} onChange={() => handleScoreChange('technical', opt.val)} style={{ marginTop: '2px' }} />
                  <div>
                    <div style={{ fontWeight: '700', fontSize: '13px', color: '#111' }}>{opt.title}</div>
                    <div style={{ fontSize: '12px', color: '#2563eb' }}>{opt.urdu}</div>
                    <div style={{ fontSize: '11px', color: '#6b7280', marginTop: '2px' }}>{opt.desc}</div>
                  </div>
                </RadioCard>
              ))}
            </div>
          </Section>

          {/* SEC 2 */}
          <Section title="2. Work Experience" urdu="کام کا تجربہ" badge={`${scores.experience}/20`} color="#7c3aed">
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '10px' }}>
              {[{ val: 0, lbl: "< 1 Year", urdu: "ایک سال سے کم" }, { val: 10, lbl: "1–3 Years", urdu: "1-3 سال" }, { val: 15, lbl: "3–5 Years", urdu: "3-5 سال" }, { val: 20, lbl: "5+ Years", urdu: "5 سال سے زیادہ" }].map(opt => (
                <RadioCard key={opt.val} selected={String(scores.experience) === String(opt.val)} onClick={() => handleScoreChange('experience', opt.val)} accent="#7c3aed">
                  <input type="radio" name="experience" value={opt.val} checked={String(scores.experience) === String(opt.val)} onChange={() => handleScoreChange('experience', opt.val)} />
                  <div><div style={{ fontWeight: '700', fontSize: '13px' }}>{opt.lbl}</div><div style={{ fontSize: '12px', color: '#7c3aed' }}>{opt.urdu}</div></div>
                </RadioCard>
              ))}
            </div>
          </Section>

          {/* SEC 3 */}
          <Section title="3. Qualification & Extras" urdu="قابلیت اور اضافی سرٹیفکیٹ" badge={`${(parseInt(scores.qualification) || 0) + (scores.extraCert ? 5 : 0)}/25`} color="#0891b2">
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '10px', marginBottom: '10px' }}>
              {[{ val: 0, lbl: "Below Matric", urdu: "میٹرک سے کم" }, { val: 10, lbl: "Matric/Inter", urdu: "میٹرک / انٹر" }, { val: 15, lbl: "Diploma", urdu: "ڈپلومہ" }, { val: 20, lbl: "Bachelors", urdu: "بیچلر" }].map(opt => (
                <RadioCard key={opt.val} selected={String(scores.qualification) === String(opt.val)} onClick={() => handleScoreChange('qualification', opt.val)} accent="#0891b2">
                  <input type="radio" name="qualification" value={opt.val} checked={String(scores.qualification) === String(opt.val)} onChange={() => handleScoreChange('qualification', opt.val)} />
                  <div><div style={{ fontWeight: '700', fontSize: '13px' }}>{opt.lbl}</div><div style={{ fontSize: '12px', color: '#0891b2' }}>{opt.urdu}</div></div>
                </RadioCard>
              ))}
            </div>
            <CheckCard checked={scores.extraCert} onChange={() => handleCheckboxChange('extraCert')} label="Extra Certificates (Solar/Safety)" urdu="اضافی سرٹیفکیٹ" bonus="+5 Marks" accent="#0891b2" />
          </Section>

          {/* SEC 4 */}
          <Section title="4. Area, Communication & Mobility" urdu="علاقہ، مواصلات اور نقل و حرکت" badge={`${areaScore}/45`} color="#059669">
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(195px, 1fr))', gap: '10px' }}>
              {[
                { key: 'outdoor', lbl: 'Outdoor work (heat/dust)', urdu: 'بیرونی کام (گرمی / مٹی)', pts: '+5' },
                { key: 'fitness', lbl: 'Physical fitness', urdu: 'جسمانی صحت', pts: '+10' },
                { key: 'localFamiliarity', lbl: 'Local site/route knowledge', urdu: 'مقامی راستوں کا علم', pts: '+10' },
                { key: 'travel', lbl: 'Willingness to travel/night duty', urdu: 'سفر / رات کی ڈیوٹی', pts: '+5' },
                { key: 'urdu', lbl: 'Read & write Urdu', urdu: 'اردو لکھنا اور پڑھنا', pts: '+5' },
                { key: 'english', lbl: 'Read & write English', urdu: 'انگریزی لکھنا اور پڑھنا', pts: '+5' },
                { key: 'bike', lbl: 'Can drive a bike', urdu: 'بائیک چلا سکتا ہے', pts: '+5' },
              ].map(opt => (
                <CheckCard key={opt.key} checked={scores.areaAttributes[opt.key]} onChange={() => handleCheckboxChange('areaAttributes', opt.key)} label={opt.lbl} urdu={opt.urdu} bonus={opt.pts} accent="#059669" />
              ))}
            </div>
          </Section>

          {/* SEC 5 */}
          <Section title="5. Safety, Discipline & Digital" urdu="حفاظت، نظم و ضبط اور ڈیجیٹل مہارتیں" badge={`${safetyScore}/20`} color="#dc2626">
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(195px, 1fr))', gap: '10px' }}>
              {[
                { key: 'ppe', lbl: 'Use of PPE', urdu: 'حفاظتی سامان کا استعمال' },
                { key: 'electricalHeight', lbl: 'Electrical & height safety', urdu: 'بجلی اور اونچائی کی حفاظت' },
                { key: 'discipline', lbl: 'Discipline & SOP compliance', urdu: 'نظم و ضبط اور ایس او پی' },
                { key: 'digitalSkills', lbl: 'Smartphone / Laptop use', urdu: 'اسمارٹ فون / لیپ ٹاپ' },
              ].map(opt => (
                <CheckCard key={opt.key} checked={scores.safety[opt.key]} onChange={() => handleCheckboxChange('safety', opt.key)} label={opt.lbl} urdu={opt.urdu} bonus="+5" accent="#dc2626" />
              ))}
            </div>
          </Section>

          {/* RESULT BAR */}
          <div style={{ background: 'linear-gradient(135deg, #0f172a, #1e3a8a)', borderRadius: '12px', padding: '18px 22px', color: 'white', marginBottom: '20px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px', marginBottom: '14px' }}>
              <div>
                <div style={{ fontSize: '11px', color: '#93c5fd', textTransform: 'uppercase', letterSpacing: '1.5px' }}>Total Score | کل نمبر</div>
                <div style={{ fontSize: '34px', fontWeight: '900', lineHeight: 1 }}>{totalScore} <span style={{ fontSize: '16px', color: '#93c5fd', fontWeight: '400' }}>/ 125</span></div>
              </div>
              {decision && (
                <div style={{ background: decision === 'Not Selected' ? '#fef2f2' : '#ecfdf5', color: decisionColor, padding: '8px 20px', borderRadius: '50px', fontWeight: '700', fontSize: '14px', border: `2px solid ${decisionColor}` }}>
                  {decision === 'FO' ? '✅ Selected (FO)' : decision === 'Supervisor' ? '⭐ Selected (Supervisor)' : '❌ Not Selected'}
                </div>
              )}
            </div>
            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
              {[{ val: 'FO', label: '✅ Selected (FO)' }, { val: 'Supervisor', label: '⭐ Supervisor' }, { val: 'Not Selected', label: '❌ Not Selected' }].map(opt => (
                <label key={opt.val} style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '5px 14px', borderRadius: '50px', border: `1px solid ${decision === opt.val ? '#60a5fa' : 'rgba(255,255,255,0.25)'}`, background: decision === opt.val ? 'rgba(96,165,250,0.2)' : 'transparent', cursor: 'pointer', fontSize: '13px', color: 'white' }}>
                  <input type="radio" name="decision" checked={decision === opt.val} onChange={() => setDecision(opt.val)} /> {opt.label}
                </label>
              ))}
            </div>

            {/* EMAIL NOTICE */}
            {(decision === 'FO' || decision === 'Supervisor') && (
              <div style={{ marginTop: '12px', background: 'rgba(255,255,255,0.10)', border: '1px solid rgba(255,255,255,0.25)', borderRadius: '8px', padding: '10px 14px', display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', color: '#bfdbfe' }}>
                <span style={{ fontSize: '16px' }}>📧</span>
              </div>
            )}
          </div>

          {/* REMARKS */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '20px' }}>
            <Field label="Selected for Project / Site" urdu="منتخب شدہ پراجیکٹ / سائٹ">
              <textarea style={{ ...inp, height: '70px', resize: 'vertical' }} placeholder="Project or site name..." value={remarks} onChange={(e) => setRemarks(e.target.value)} />
            </Field>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <Field label="Evaluator Name" urdu="جائزہ لینے والے کا نام">
                <input style={inp} value={evaluatorName} onChange={(e) => setEvaluatorName(e.target.value)} placeholder="Evaluator name..." />
              </Field>
              <Field label="Signature" urdu="دستخط">
                <input style={{ ...inp, background: '#f9fafb', color: '#9ca3af' }} disabled placeholder="Digital Signature" />
              </Field>
            </div>
          </div>

          {/* SAVE BUTTON */}
          <button
            onClick={handleSave}
            disabled={isSubmitting}
            style={{ width: '100%', padding: '14px', background: isSubmitting ? '#9ca3af' : 'linear-gradient(135deg, #1e3a8a, #2563eb)', color: 'white', border: 'none', borderRadius: '10px', fontSize: '15px', fontWeight: '700', cursor: isSubmitting ? 'not-allowed' : 'pointer', boxShadow: '0 4px 15px rgba(30,58,138,0.4)', letterSpacing: '0.3px' }}
          >
            {isSubmitting
              ? '⏳ Saving... | محفوظ ہو رہا ہے...'
              : (decision === 'FO' || decision === 'Supervisor')
                ? `💾 Save & Send Email to ${NOTIFY_EMAIL}`
                : '💾 Save to Google Sheets | گوگل شیٹ میں محفوظ کریں'
            }
          </button>
          <p style={{ textAlign: 'center', fontSize: '11px', color: '#9ca3af', marginTop: '8px' }}>
            تمام سوالات، نمبر اور فیصلہ محفوظ ہوگا۔ All data including scores & decision will be saved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default HiringForm;